<template>
  <div class="calender-schedule-detail-del-preview-component">
    <hi-dialog class="dialog" title="Screenshot" @close="close()">
      <div class="scroll-view">
        <div class="image-container">
          <div class="error-img" v-show="!image">
            <div>Screenshot failed</div>
          </div>
          <image-shade class="image-shade" :src="image">
            <img style="width: 100%" :src="image" />
          </image-shade>
        </div>
        <div class="bottom-container"></div>
      </div>
    </hi-dialog>
  </div>
</template>

<style lang="less" scoped>
@import "../../../../assets/style/theme";

.calender-schedule-detail-del-preview-component {
  width: 375px;
  .dialog {
    height: 700px;
    .scroll-view {
      display: flex;
      flex-direction: column;
      overflow: auto;
      flex: 1;
      .image-container {
        flex: 1;
        .error-img {
          width: 100%;
          height: 375px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #cccccc;
          color: white;
          font-size: 24px;
          font-weight: lighter;
        }
        .image-shade {
          height: 666px;
          img {
            width: 100%;
          }
        }
      }
      .bottom-container {
        border-top: 1px solid #e6e6e6;
        flex: 1;
      }
    }
  }
}
</style>
<script>
import hiDialog from "../../../common/dialog/Index.vue";
import ImageShade from "../../../common/media/ImageShade";

export default {
  name: "DetailDeleteComponent",
  components: { ImageShade, hiDialog },
  props: {
    image: {
      type: String,
      require: true,
    },
  },
  methods: {
    /**
     * 关闭按钮
     */
    close() {
      this.$parent.showDelPreviewModal = false;
    },
  },
};
</script>
